
import React from 'react';
import { useBooking } from '../../hooks/useBookingContext';
import { Switch } from '@/components/ui/switch';

const daysOfWeek = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
];

const Availability: React.FC = () => {
  const { currentBookingLink, updateAvailability } = useBooking();

  if (!currentBookingLink) return null;

  const handleToggleDay = (day: string, enabled: boolean) => {
    updateAvailability(day, { enabled });
  };

  const handleTimeChange = (
    day: string,
    type: 'startTime' | 'endTime',
    value: string
  ) => {
    updateAvailability(day, { [type]: value });
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <p className="text-sm text-muted-foreground mb-4">
        Set your weekly availability. People will be able to book meetings during these times.
      </p>

      <div className="space-y-4">
        {daysOfWeek.map((day) => (
          <div
            key={day.id}
            className={`p-4 rounded-xl border border-border ${
              currentBookingLink.availability[day.id]?.enabled
                ? 'bg-card'
                : 'bg-muted/30'
            }`}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <Switch
                  checked={currentBookingLink.availability[day.id]?.enabled || false}
                  onCheckedChange={(checked) =>
                    handleToggleDay(day.id, checked)
                  }
                />
                <span className="font-medium">{day.label}</span>
              </div>
            </div>

            {currentBookingLink.availability[day.id]?.enabled && (
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="block text-sm text-muted-foreground">
                    Start Time
                  </label>
                  <input
                    type="time"
                    className="w-full rounded-md border border-input bg-background px-3 py-2"
                    value={currentBookingLink.availability[day.id]?.startTime || '09:00'}
                    onChange={(e) =>
                      handleTimeChange(day.id, 'startTime', e.target.value)
                    }
                  />
                </div>
                <div className="space-y-2">
                  <label className="block text-sm text-muted-foreground">
                    End Time
                  </label>
                  <input
                    type="time"
                    className="w-full rounded-md border border-input bg-background px-3 py-2"
                    value={currentBookingLink.availability[day.id]?.endTime || '17:00'}
                    onChange={(e) =>
                      handleTimeChange(day.id, 'endTime', e.target.value)
                    }
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Availability;
